import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useState, useEffect, useRef } from "react";

const DropdownSearch = ({
  label,
  classes,
  containerClasses,
  value,
  setValue,
  option = [],
  disable = false,
  show = "label",
  val = "value",
  error = "",
  setError = null,
}) => {
  const [showOption, setShowOption] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOption(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      className={`size-full relative border border-gray-300 rounded-md z-20 transition-all ${
        containerClasses || ""
      }`}
    >
      {label && (
        <label
          className={`z-10 absolute left-3 transition-all text-gray-500 bg-white px-1 ${
            showOption || value
              ? "-top-2 text-sm text-blue-500"
              : "top-1/2 -translate-y-1/2"
          }`}
        >
          {label || ""}
        </label>
      )}
      <div
        className={`size-full bg-transparent outline-none px-4 h-10 flex justify-start items-center cursor-pointer text-black bg-white rounded-md ${
          classes || ""
        }`}
        onClick={() => !disable && setShowOption(!showOption)}
      >
        {value?.[show] || ""}
      </div>

      {!value && (
        <ChevronDownIcon
          className={`absolute right-2 top-1/2 -translate-y-1/2 size-4 transition-all text-gray-500 ${
            showOption && "rotate-180"
          } ${disable ? "cursor-not-allowed" : "cursor-pointer"}`}
          onClick={() => !disable && setShowOption(!showOption)}
        />
      )}

      {value && (
        <XMarkIcon
          className={`absolute right-2 top-1/2 -translate-y-1/2 size-4 transition-all text-gray-500 ${
            showOption && "rotate-180"
          } ${disable ? "cursor-not-allowed" : "cursor-pointer"}`}
          onClick={() => setValue("")}
        />
      )}

      {!disable && showOption && (
        <ul className="flex flex-col w-full z-40 absolute top-[calc(100%+5px)] rounded-md divide-y divide-gray-400 bg-white border border-gray-400 max-h-[247px] overflow-y-auto shadow-2xl">
          {option.length > 0 ? (
            option.map((item, index) => (
              <li
                key={`${item?.[val]}-${index}`}
                className={`p-2 text-black hover:text-white hover:bg-blue-600 cursor-pointer z-40 ${
                  item?.[val] === value?.[val] ? "text-blue-500" : ""
                }`}
                onClick={() => {
                  setValue(item);
                  if (setError) {
                    setError();
                  }
                  setTimeout(() => {
                    setShowOption(false);
                  }, 100);
                }}
              >
                {item?.[show] || ""}
              </li>
            ))
          ) : (
            <img
              src="/static/image/no-data.jpg"
              className="w-full h-[245px] object-cover"
            />
          )}
        </ul>
      )}

      {error && (
        <span className="absolute top-full left-0 text-red-600 text-xs font-semibold">
          {error}
        </span>
      )}
    </div>
  );
};

export default DropdownSearch;
